module.exports = __webpack_public_path__ + "images/emoji/pencil2.6fbcedf6f99b2d41c883.png";